module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=IO - British Indian Ocean Territory.48128b10.svg";